module.exports = new __parcel__URL__("button.2a63e86a.png").toString();